// tab-panel — wireframe skin module
// Token disposition: color tokens overridden to wf-* namespace; spacing/sizing pass-through

export const styles = `
  :host {
    display: block;
    --_padding: var(--run-tab-panel-padding, var(--run-space-semantic-md));
    --_background: var(--run-wf-surface);
    --_color: var(--run-wf-text);
  }

  :host([hidden]) {
    display: none;
  }

  :host(:focus-visible) {
    outline: 1px dashed var(--run-wf-border);
    outline-offset: 2px;
  }

  [part="base"] {
    padding-block: var(--_padding);
    padding-inline: var(--_padding);
    background: var(--_background);
    color: var(--_color);
    border: 1px dashed var(--run-wf-border);
    font-family: var(--run-wf-font-family);
    font-weight: 400;
  }
`;

export function render(host) {
  const { active } = host;
  host.shadowRoot.innerHTML = `
    <div part="base"${active ? ' data-active' : ''}>
      <slot></slot>
    </div>
  `;
}
